var CHANGELOG: any = [{
	version: '3.13.4',
	date: '18/09/2026',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.13.3',
	date: '16/09/2026',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.13.2',
	date: '22/04/2026',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.13.1',
	date: '02/12/2025',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.13.0',
	date: '17/11/2025',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.18',
	date: '22/09/2025',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.17',
	date: '17/04/2025',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.16',
	date: '03/03/2025',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.15',
	date: '16/12/2024',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.14',
	date: '15/10/2024',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.13',
	date: '25/03/2024',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.12',
	date: '24/01/2024',
	changelog: [
		{ type: 'bug-fix', text: 'Fixed issue with COVID-19 Health Information Sheets' },
	]
},{
	version: '3.12.11',
	date: '12/01/2024',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.10',
	date: '18/12/2023',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.9',
	date: '06/11/2023',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.8',
	date: '01/09/2023',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.7',
	date: '10/05/2023',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.6',
	date: '08/05/2023',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.5',
	date: '13/04/2023',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.3',
	date: '17/11/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.2',
	date: '06/09/2022',
	changelog: [
		{ type: 'checklist', text: 'ACT-FAST' },
	]
},{
	version: '3.12.1',
	date: '10/08/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.12.0',
	date: '02/08/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.13',
	date: '10/06/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.12',
	date: '16/05/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.11',
	date: '11/04/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.10',
	date: '07/03/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.9',
	date: '01/03/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.8',
	date: '23/02/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.7',
	date: '09/02/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.5',
	date: '21/01/2022',
	changelog: [
		{ type: 'content', text: 'VED induction link' },
	]
},{
	version: '3.11.4',
	date: '20/01/2022',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.3',
	date: '13/12/2021',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.2',
	date: '27/10/2021',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.11.1',
	date: '22/10/2021',
	changelog: [
		{ type: 'info', text: 'COVID-19 Health Information Sheets available in multiple languages' },
	]
},{
	version: '3.11.0',
	date: '14/10/2021',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.10.3',
	date: '22/09/2021',
	changelog: [
		{ type: 'content', text: 'Clinical updates' },
	]
},{
	version: '3.10.2',
	date: '21/09/2021',
	changelog: [
		{ type: 'content-new', text: 'COVID-19 Management' },
		{ type: 'content', text: 'COVID-19 Modifications to usual care' },
		{ type: 'checklist-new', text: 'Program pilot – Virtual Emergency' },
	]
},{
	version: '3.10.1',
	date: '20/08/2021',
	changelog: [
		{ type: 'bug-fix', text: 'Fixed an issue with links not opening on certain devices' },
	]
},{
	version: '3.10.0',
	date: '20/08/2021',
	changelog: [
		{ type: 'info', text: 'New tab added - Further Information' },
		{ type: 'info', text: 'Settings and support section now accessed via cog button in top right of Home tab' },
		{ type: 'info', text: 'Pages that have been updated now have a dot icon next to them following an app update' },
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.9.3',
	date: '13/05/2021',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.9.2',
	date: '19/04/2021',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.9.1',
	date: '03/03/2021',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.9.0',
	date: '25/02/2021',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.8.2',
	date: '18/02/2021',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.8.1',
	date: '17/12/2020',
	changelog: [
		{ type: 'calculator', text: 'Medication Calculator' },
		{ type: 'bug-fix', text: 'Clinical updates dates corrected' },
	]
},{
	version: '3.8.0',
	date: '16/12/2020',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.7.0',
	date: '26/11/2020',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.6.2',
	date: '06/11/2020',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.6.1',
	date: '05/11/2020',
	changelog: [
		{ type: 'content', text: 'Adult » Pain Relief » Headache' },
		{ type: 'calculator', text: 'Medication Calculator' },
	]
},{
	version: '3.6.0',
	date: '02/11/2020',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.5.3',
	date: '25/09/2020',
	changelog: [
		{ type: 'bug-fix', text: 'Bug fixes' },
	]
},{
	version: '3.5.2',
	date: '21/09/2020',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.5.1',
	date: '31/07/2020',
	changelog: [
		{ type: 'bug-fix', text: 'Fixed problem with "CPG D001 Aspirin" not showing content' },
	]
},{
	version: '3.5.0',
	date: '22/07/2020',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.4.1',
	date: '29/05/2020',
	changelog: [
		{ type: 'bug-fix', text: 'Platform updates' },
	]
},{
	version: '3.4.0',
	date: '19/05/2020',
	changelog: [
		{ type: 'content', text: 'COVID-19' },
	]
},{
	version: '3.3.0',
	date: '02/04/2020',
	changelog: [
		{ type: 'content-new', text: 'COVID-19' },
	]
},{
	version: '3.2.1',
	date: '18/02/2020',
	changelog: [
		{ type: 'bug-fix', text: 'Print image updates' },
	]
},{
	version: '3.2.0',
	date: '14/02/2020',
	changelog: [
		{ type: 'bug-fix', text: 'Fixed problem where tap to zoom images was not working on all devices' },
	]
},{
	version: '3.1.1',
	date: '13/02/2020',
	changelog: [
		{ type: 'content', text: 'See "Clinical updates" page for changes' },
	]
},{
	version: '3.1.0',
	date: '13/01/2020',
	changelog: [
		{ type: 'bug-fix', text: 'Platform updates' },
	]
},{
	version: '3.0.0 Update 1',
	date: '29/11/2019',
	changelog: [
		{ type: 'info', text: '"Miscarriage" page moved from "Further Information" to "Maternity" section' },
		{ type: 'content-new', text: 'Medicines » Paracetamol (FR)' },
		{ type: 'content', text: 'Adult » Assessment » Ottawa Ankle Rules' },
		{ type: 'content', text: 'Adult » Cardiac Arrest » Medical Cardiac Arrest' },
		{ type: 'content', text: 'Paediatric » Assessment » Assessment Introduction' },
		{ type: 'content', text: 'Paediatric » Airway Management » Endotracheal Intubation » Preparation' },
		{ type: 'content', text: 'Paediatric » Pain Relief' },
		{ type: 'content', text: 'First Responders » Paediatric Assessment » Initial Paediatric Assessment' },
	]
},{
	version: '3.0.0',
	date: '14/11/2019',
	changelog: [
		{ type: 'info', text: 'Version 3 release' },
	]
},{
	version: '1.0.2',
	date: '12/02/2019',
	changelog: [
		{ type: 'checklist-new', text: 'High-Performance CPR – Intra-arrest' },
		{ type: 'checklist-new', text: 'High-Performance CPR – ROSC management' },
		{ type: 'checklist-new', text: 'Zoll X case push' },
		{ type: 'content', text: 'Adult Patient » Cardiac Arrest » Medical Cardiac Arrest' },
		{ type: 'content', text: 'Paediatric Patient » Cardiac Arrest » Medical Cardiac Arrest' },
	]
},{
	version: '1.0.1 Update 8',
	date: '18/12/2018',
	changelog: [
		{ type: 'content', text: 'Adult Patient » Pain Relief » Pain Relief' },
		{ type: 'content', text: 'Adult Patient » Medical » Agitated Patient' },
		{ type: 'content', text: 'Adult Patient » Trauma » Chest Injuries' },
		{ type: 'content', text: 'Adult Patient » Trauma » Elderly/Frail Non-Injury Fall' },
		{ type: 'content', text: 'Paediatric Patient » Cardiac Arrest » Cardiac Arrest' },
		{ type: 'content', text: 'Paediatric Patient » Pain Relief' },
		{ type: 'content', text: 'Maternity Patient » Normal Birth' },
		{ type: 'content', text: 'Newborn Patient » Newborn Information' },
		{ type: 'content', text: 'Newborn Patient » The Newborn Baby' },
		{ type: 'content', text: 'Pharmacology » Atropine' },
		{ type: 'content', text: 'Pharmacology » Salbutamol' },
		{ type: 'content', text: 'Phone Numbers' },
		{ type: 'calculator', text: 'Medication Calculator' },
	]
},{
	version: '1.0.1 Update 7',
	date: '26/10/2018',
	changelog: [
		{ type: 'content-removed', text: 'Adult Patient » Assessment » Time Critical Guidelines (Medical)' },
		{ type: 'calculator', text: 'Burns Fluid Calculator' },
		{ type: 'content', text: 'Settings and support » About' },
	]
},{
	version: '1.0.1 Update 6',
	date: '25/10/2018',
	changelog: [
		{ type: 'bug-fix', text: 'Bug fix: Pharmacology » Midazolam was not loading' },
		{ type: 'content', text: 'Adult Patient » Medical » Anaphylaxis' },
	]
},{
	version: '1.0.1 Update 5',
	date: '23/10/2018',
	changelog: [
		{ type: 'content-new', text: 'Adult Patient » Trauma » Principles of Major Trauma' },
		{ type: 'calculator-new', text: 'Burns Fluid Calculator' },
		{ type: 'checklist-new', text: 'Neurological Exam for Spinal Clearance' },
		{ type: 'content', text: 'Adult Patient » Pain Relief » Pain Relief' },
		{ type: 'content', text: 'Adult Patient » Pain Relief » Headache' },
		{ type: 'content', text: 'Adult Patient » Medical » Nausea and Vomiting' },
		{ type: 'content', text: 'Adult Patient » Medical » Inadeq. Perfusion (Non-cardiogenic / Non-hypovolaemic)' },
		{ type: 'content', text: 'Adult Patient » Trauma » Haemorrhagic Hypovolaemia' },
		{ type: 'content', text: 'Adult Patient » Trauma » Chest Injuries' },
		{ type: 'content', text: 'Adult Patient » Trauma » Traumatic Head Injury' },
		{ type: 'content', text: 'Adult Patient » Trauma » Spinal Injury' },
		{ type: 'content', text: 'Adult Patient » Trauma » Burns' },
		{ type: 'content', text: 'Adult Patient » Trauma » Fracture/Dislocation' },
		{ type: 'content', text: 'Adult Patient » Trauma » Diving Related Emergencies' },
		{ type: 'content', text: 'Adult Patient » Environment » Hyperthermia / Heat Stress' },
		{ type: 'content', text: 'Paediatric Patient » Pain Relief' },
		{ type: 'content', text: 'Paediatric Patient » Respiratory » Asthma' },
		{ type: 'content', text: 'Paediatric Patient » Medical » Anaphylaxis' },
		{ type: 'content', text: 'Paediatric Patient » Trauma » Chest Injuries' },
		{ type: 'content', text: 'Paediatric Patient » Trauma » Paediatric Burns' },
		{ type: 'content', text: 'Maternity Patient » Antepartum Haemorrhage' },
		{ type: 'content', text: 'Maternity Patient » Primary Postpartum Haemorrhage (PPPH)' },
		{ type: 'checklist', text: 'Spinal Immobilisation Clearance' },
	]
},{
	version: '1.0.1 Update 4',
	date: '27/08/2018',
	changelog: [
		{ type: 'content', text: 'Adult Patient » Medical » Anaphylaxis' },
		{ type: 'checklist', text: 'Research Trials - ACT-FAST' },
	]
},{
	version: '1.0.1 Update 3',
	date: '02/07/2018',
	changelog: [
		{ type: 'content-new', text: 'Pharmacology » Rocuronium' },
		{ type: 'content', text: 'Adult Patient » Assessment » Clinical Flags' },
		{ type: 'content', text: 'Adult Patient » Airway Management » Endotracheal Intubation » Post Intubation' },
		{ type: 'content', text: 'Adult Patient » Respiratory » Asthma » Asthma' },
		{ type: 'content', text: 'Paediatric Patient » Airway Management » Post Intubation' },
		{ type: 'calculator', text: 'Medication Calculator' },
	]
},{
	version: '1.0.1 Update 2',
	date: '22/05/2018',
	changelog: [
		{ type: 'content', text: 'AAV CPGs » Adult Patient » Pain Relief' },
		{ type: 'content', text: 'AAV CPGs » Adult Patient » Inadequate Perfusion Associated with Hypovolemia' },
	]
},{
	version: '1.0.1 Update 1',
	date: '09/05/2018',
	changelog: [
		{ type: 'content', text: 'Paediatric Patient » Respiratory » Upper Airway Obstruction' },
		{ type: 'content', text: 'Paediatric Patient » Medical » Seizures' },
		{ type: 'content', text: 'Paediatric Patient » Trauma » Paediatric Burns' },
		{ type: 'content', text: 'Pharmacology » Prochlorperazine (Stemetil)' },
		{ type: 'content', text: 'Further Information » DCCS (Direct Current Counter Shock)' },
		{ type: 'checklist', text: 'RSI preparation' },
		{ type: 'checklist', text: 'CPAP' },
		{ type: 'checklist', text: 'Research Trials - ACT-FAST' },
	]
},{
	version: '1.0.1',
	date: '29/03/2018',
	changelog: [
		{ type: 'info', text: 'Disclaimer added to splash screen' },
	]
},{
	version: '1.0.0',
	date: '28/02/2018',
	changelog: [
		{ type: 'info', text: 'App release' },
	]
}];

export default CHANGELOG;



// WEBPACK FOOTER //
// ./src/pages/settings/version-history/version-data/changelog-public.ts